import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type HTMLAttributes, computed } from "vue";
import { AccordionContent, type AccordionContentProps } from "radix-vue";
import { cn } from "@/lib/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccordionContent',
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(__props: any) {

const props = __props;

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AccordionContent), _mergeProps(delegatedProps.value, { class: "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down" }), {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(cn)('pb-4 pt-0 text-muted-foreground text-[16px]', props.class))
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _: 3
  }, 16))
}
}

})